import React, { useState } from "react";

export default function Collab() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = encodeURIComponent("Africa Loud Collaboration Inquiry");
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\n\nMessage:\n${form.message}`
    );

    window.location.href = `mailto:hello@africaloudmag.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="min-h-screen bg-white px-4 py-16">
      <div className="mx-auto max-w-2xl">
        <h1 className="text-3xl font-serif tracking-tight text-neutral-900">
          Collaborate with Africa Loud
        </h1>

        <p className="mt-4 text-neutral-600 leading-relaxed">
          We partner with brands, institutions, and creatives entering African
          culture markets. Tell us about your vision below.
        </p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-6">
          <div>
            <label className="block text-sm font-semibold text-neutral-700">
              Name
            </label>
            <input
              type="text"
              name="name"
              required
              value={form.name}
              onChange={handleChange}
              className="mt-2 w-full border border-black/20 px-4 py-3 outline-none focus:border-black"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-neutral-700">
              Email
            </label>
            <input
              type="email"
              name="email"
              required
              value={form.email}
              onChange={handleChange}
              className="mt-2 w-full border border-black/20 px-4 py-3 outline-none focus:border-black"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-neutral-700">
              Message
            </label>
            <textarea
              name="message"
              rows="6"
              required
              value={form.message}
              onChange={handleChange}
              className="mt-2 w-full border border-black/20 px-4 py-3 outline-none focus:border-black"
            />
          </div>

          <button
            type="submit"
            className="inline-flex items-center justify-center border border-black bg-black px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white transition hover:opacity-90"
          >
            Send Collaboration Request
          </button>
        </form>
      </div>
    </div>
  );
}
